import { Component } from '@angular/core';
import { baseAttachDto } from 'src/app/tabms/models/base/base';

@Component({
  selector: 'app-base-attach-view',
  templateUrl: './base-attach-view.component.html',
  styleUrl: './base-attach-view.component.scss'
})
export class BaseAttachViewComponent {
  
  attachedFiles: baseAttachDto[] = [];

  constructor(){
  }
  
}
